// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_wrapper__ryjZf {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.overlay_wrapper__ryjZf > svg {
  fill: var(--overlayForeground);
  position: absolute;
  animation: overlay_fadeIn__zY8A9 0.5s both;
}

.overlay_volumeLabel__x9ohg {
  width: 125px;
  height: 60px;
  background-color: var(--labelOverlayColor);

  text-align: center;
  line-height: 60px;
  font-size: 12px;
}

.overlay_volumeWrapper__2PJ2Z svg {
  fill: var(--overlayForeground);
  display: block;
  margin: auto;
  margin-bottom: 14px;
}

.overlay_stepIndicatorWrapper__qZfoR {
  width: 60%;
  display: flex;
  justify-content: left;
}

.overlay_forwardIndicator__azY1I {
  justify-content: right;
}

.overlay_stepIndicator__5vhOW {
  width: min(37%, 129px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay_stepIndicator__5vhOW svg {
  width: 100%;
}

.overlay_stepIndicator__5vhOW svg circle {
  fill: var(--labelOverlayColor);
}

.overlay_stepIndicatorLabel__oIjkk {
  position: absolute;
  margin-top: 30px;
  font-weight: 400;
  -webkit-user-select: none;
          user-select: none;
}

@media (prefers-reduced-motion) {
  .overlay_wrapper__ryjZf > svg {
    animation-duration: 0s;
  }
}

@keyframes overlay_fadeIn__zY8A9 {
  from {
    opacity: 1;
    transform: scale(0.5);
  }

  to {
    opacity: 0;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/overlay/overlay.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,0CAA0C;;EAE1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 100%;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.wrapper > svg {\n  fill: var(--overlayForeground);\n  position: absolute;\n  animation: fadeIn 0.5s both;\n}\n\n.volumeLabel {\n  width: 125px;\n  height: 60px;\n  background-color: var(--labelOverlayColor);\n\n  text-align: center;\n  line-height: 60px;\n  font-size: 12px;\n}\n\n.volumeWrapper svg {\n  fill: var(--overlayForeground);\n  display: block;\n  margin: auto;\n  margin-bottom: 14px;\n}\n\n.stepIndicatorWrapper {\n  width: 60%;\n  display: flex;\n  justify-content: left;\n}\n\n.forwardIndicator {\n  justify-content: right;\n}\n\n.stepIndicator {\n  width: min(37%, 129px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stepIndicator svg {\n  width: 100%;\n}\n\n.stepIndicator svg circle {\n  fill: var(--labelOverlayColor);\n}\n\n.stepIndicatorLabel {\n  position: absolute;\n  margin-top: 30px;\n  font-weight: 400;\n  user-select: none;\n}\n\n@media (prefers-reduced-motion) {\n  .wrapper > svg {\n    animation-duration: 0s;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 1;\n    transform: scale(0.5);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `overlay_wrapper__ryjZf`,
	"fadeIn": `overlay_fadeIn__zY8A9`,
	"volumeLabel": `overlay_volumeLabel__x9ohg`,
	"volumeWrapper": `overlay_volumeWrapper__2PJ2Z`,
	"stepIndicatorWrapper": `overlay_stepIndicatorWrapper__qZfoR`,
	"forwardIndicator": `overlay_forwardIndicator__azY1I`,
	"stepIndicator": `overlay_stepIndicator__5vhOW`,
	"stepIndicatorLabel": `overlay_stepIndicatorLabel__oIjkk`
};
export default ___CSS_LOADER_EXPORT___;
